"use client";

import { HelpCircle } from "lucide-react";
import { useState } from "react";

const CHORDPRO_SPEC_URL =
  "https://www.chordpro.org/chordpro/chordpro-directives/";

export function ChordProHelp() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <details
      className="inline"
      open={isOpen}
      onToggle={(e) => setIsOpen(e.currentTarget.open)}
    >
      <summary
        className="ml-2 inline-flex cursor-pointer items-center justify-center rounded-md p-1 text-text-muted transition-colors hover:bg-bg-tertiary hover:text-text-secondary"
        aria-label="ChordPro help"
      >
        <HelpCircle size={14} />
      </summary>
      <div className="absolute z-10 mt-2 w-72 normal-case rounded-lg border border-border-subtle bg-bg-secondary p-4 shadow-lg sm:w-80">
        <h3 className="mb-3 font-mono text-xs font-medium uppercase tracking-widest text-text-muted">
          Quick Reference
        </h3>
        <dl className="space-y-2 font-mono text-xs">
          <div className="flex gap-3">
            <dt className="w-24 shrink-0 text-amber">[Am] [C7]</dt>
            <dd className="text-text-secondary">Inline chords</dd>
          </div>
          <div className="flex gap-3">
            <dt className="w-24 shrink-0 text-amber">{"{sov} {eov}"}</dt>
            <dd className="text-text-secondary">Start/end verse</dd>
          </div>
          <div className="flex gap-3">
            <dt className="w-24 shrink-0 text-amber">{"{soc} {eoc}"}</dt>
            <dd className="text-text-secondary">Start/end chorus</dd>
          </div>
          <div className="flex gap-3">
            <dt className="w-24 shrink-0 text-amber">{"{sob} {eob}"}</dt>
            <dd className="text-text-secondary">Start/end bridge</dd>
          </div>
          <div className="flex gap-3">
            <dt className="w-24 shrink-0 text-amber">{"{c: text}"}</dt>
            <dd className="text-text-secondary">Comment</dd>
          </div>
          <div className="flex gap-3">
            <dt className="w-24 shrink-0 text-amber">{"{chord: Am}"}</dt>
            <dd className="text-text-secondary">Chord diagram</dd>
          </div>
          <div className="flex flex-col gap-1">
            <dt className="text-amber">
              {"{define: X base-fret 1 frets x 1 2 3 4 5}"}
            </dt>
            <dd className="text-text-secondary">Custom fingering</dd>
          </div>
        </dl>
        <div className="mt-4 border-t border-border-subtle pt-3">
          <a
            href={CHORDPRO_SPEC_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-text-muted transition-colors hover:text-amber"
          >
            Full ChordPro spec →
          </a>
        </div>
      </div>
    </details>
  );
}
